module.exports = __webpack_public_path__ + "img/emoji_18.83b18f2a.png";